import React, { useEffect, useState } from 'react'
import api from '../../../../services/api'
import Form, { Input, Select } from '../../../../components/Form'
import { useHistory } from 'react-router-dom'
import { useToast } from '../../../../hooks/toast'
import { useLoading } from '../../../../hooks/loading'
import { useUpdateDataTable } from '../../../../hooks/dataTable'
import { apiCreate, apiUpdate } from '../../domain/api'
import { nameActions } from '../../domain/info'
import { FormContainer } from './styles'

type IsOpenInModalProps = {
  idParent: number
  handleOnClose: () => void
}

type UserData = {
  id?: string
  name?: string
  role_id?: number
  email?: string
  username?: string
  password?: string
  active?: boolean
}

type TypesFormProps = {
  isOpenInModal?: false | IsOpenInModalProps
  initialValues?: UserData & {
    idUpdate: number
  }
  typeForm: 'create' | 'update'
}

// type Role = {
//   id: number
//   name: string
// }

export const FormUser = ({
  isOpenInModal,
  initialValues,
  typeForm
}: TypesFormProps): JSX.Element => {
  const { addToast } = useToast()
  const history = useHistory()
  const { updateDataTable } = useUpdateDataTable()

  const [defaultValues, setDefaultValues] = useState<UserData>()

  // const [roles, setRoles] = useState<{ value: number; name: string }[]>([
  //   { value: 0, name: '' }
  // ])

  useEffect(() => {
    if (initialValues) {
      setDefaultValues({
        name: initialValues.name,
        email: initialValues.email,
        username: initialValues.username,
        role_id: initialValues.role_id,
        active: initialValues.active
      })
    }
  }, [initialValues])

  const { activeLoading, disableLoading } = useLoading()

  // async function getRoles() {
  //   const roles = (await api.get('/users/roles/')).data
  //   const rolesSelect = roles?.map((role: Role) => ({
  //     value: role.id,
  //     name: role.name
  //   }))
  //   setRoles(rolesSelect)
  // }

  // useEffect(() => {
  //   getRoles()
  // }, [])

  const onSubmitForm = async (data: UserData) => {
    const id = initialValues?.idUpdate
    data.role_id = 1
    if (data.active) {
      data = {
        ...data,
        active: JSON.parse(String(data.active))
      }
    }

    try {
      if (typeForm === 'create') {
        if (isOpenInModal) {
          const { handleOnClose, idParent } = isOpenInModal
          const dataCreate = {
            ...data,
            active: 'true',
            parent_id: idParent
          }
          activeLoading()
          try {
            await api.post(apiCreate(), dataCreate)
            handleOnClose()
            disableLoading()
            updateDataTable()
            addToast({
              type: 'success',
              title: 'Registro criado',
              description: 'Registro criado com sucesso'
            })
          } catch (error) {
            addToast({
              type: 'error',
              title: 'Erro ao adicionar o registro',
              description:
                'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
            })
            handleOnClose()
            disableLoading()
            updateDataTable()
          }
        } else {
          try {
            const dataCreate = {
              active: 'true',
              ...data
            }
            activeLoading()
            await api.post(apiCreate(), dataCreate)
            disableLoading()
            updateDataTable()
            addToast({
              type: 'success',
              title: 'Registro criado',
              description: 'Registro criado com sucesso'
            })
            history.push(nameActions.read.to)
          } catch (error) {
            addToast({
              type: 'error',
              title: 'Erro ao adicionar o registro',
              description:
                'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
            })
            disableLoading()
            updateDataTable()
          }
        }
      } else {
        if (isOpenInModal) {
          const { handleOnClose } = isOpenInModal
          const dataUpdate = {
            ...data
          }

          try {
            activeLoading()
            await api.put(apiUpdate(String(id)), dataUpdate)
            updateDataTable()
            disableLoading()
            handleOnClose()
            addToast({
              type: 'success',
              title: 'Registro atualizado',
              description: 'Registro alterado com sucesso'
            })
          } catch (error) {
            disableLoading()
            handleOnClose()
            addToast({
              type: 'error',
              title: 'Erro ao atualizar o registro',
              description:
                'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
            })
          }
        } else {
          const dataUpdate = {
            ...data
          }

          try {
            activeLoading()
            await api.put(apiUpdate(String(id)), dataUpdate)
            updateDataTable()
            disableLoading()
            history.push(nameActions.read.to)
            addToast({
              type: 'success',
              title: 'Registro atualizado',
              description: 'Registro alterado com sucesso'
            })
          } catch (error) {
            history.push(nameActions.read.to)
            addToast({
              type: 'error',
              title: 'Erro ao atualizar o registro',
              description:
                'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
            })
          }
        }
      }
      disableLoading()
    } catch (err) {
      if (typeForm === 'create') {
        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description:
            'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
        })
        if (isOpenInModal) isOpenInModal.handleOnClose()
      }
    }
  }

  return (
    <Form onSubmit={onSubmitForm} defaultValues={defaultValues}>
      <>
        <div className="card mb-5 mb-xl-10">
          <FormContainer className="form">
            <div className="row mb-5">
              <Input
                name="name"
                label="Nome"
                rules={{ required: true }}
                className="col-md-4"
              />
              <Input
                name="email"
                label="Email"
                rules={{ required: true }}
                className="col-md-4"
              />
              {/* <Select
                className="col-md-3"
                name="role_id"
                label="Grupo"
                options={roles}
                blank
                defaultValue={''}
                rules={{ required: true }}
              /> */}
              <Input
                name="username"
                label="Usuário"
                rules={{ required: true }}
                className="col-md-4"
              />
            </div>
            <div className="row mb-5">
              <Input
                type="password"
                name="password"
                label="Senha"
                rules={{ required: typeForm === 'create' }}
                className="col-md-4"
              />
              {typeForm === 'update' && (
                <Select
                  className="col-md-3"
                  name="active"
                  label="Ativo"
                  options={[
                    { value: 'true', name: 'Sim' },
                    { value: 'false', name: 'Não' }
                  ]}
                />
              )}
            </div>
          </FormContainer>
          <div className="card-footer d-flex justify-content-end py-6 px-9">
            <button type="submit" className="btn btn-primary">
              Salvar
            </button>
          </div>
        </div>
      </>
    </Form>
  )
}
